// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"11":"component---node-modules-nca-acquiring-theme-src-pages-404-js","54":"component---node-modules-nca-acquiring-theme-src-templates-main-template-js"}[chunkId] + "-" + {"11":"95da111d2cdb29800aa3","54":"3f33cd96b3b08eb3961a"}[chunkId] + ".js";
};